// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters

/** The number of bytes in a KZG commitment. */
export const bytesPerCommitment = 48

/** The number of bytes in a KZG proof. */
export const bytesPerProof = 48

export const versionedHashVersionKzg = 1
